import { render } from "./moduleNewsTypeManage.vue?vue&type=template&id=b849c838"
import script from "./moduleNewsTypeManage.vue?vue&type=script&lang=js"
export * from "./moduleNewsTypeManage.vue?vue&type=script&lang=js"

import "./moduleNewsTypeManage.vue?vue&type=style&index=0&id=b849c838&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__